"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.leadAttributionSnapshotSchema = exports.updateLeadAttributionSourceRequestSchema = exports.createLeadAttributionSourceRequestSchema = exports.leadAttributionSourceListResponseSchema = exports.leadAttributionSourceListQuerySchema = exports.leadAttributionSourceSchema = exports.leadAttributionSourceStatusSchema = exports.leadAttributionSourceCategorySchema = exports.leadAttributionSourceKindSchema = exports.leadAttributionSourceKeySchema = void 0;
const zod_1 = require("zod");
const lead_channel_1 = require("./lead-channel");
exports.leadAttributionSourceKeySchema = zod_1.z
    .string()
    .trim()
    .min(2)
    .max(80)
    .regex(/^[a-z0-9]+(?:[._-][a-z0-9]+)*$/);
exports.leadAttributionSourceKindSchema = zod_1.z.enum(["SYSTEM", "CUSTOM"]);
exports.leadAttributionSourceCategorySchema = zod_1.z.enum([
    "DIRECT",
    "REFERRAL",
    "ORGANIC",
    "PAID",
    "MARKETPLACE",
    "PARTNER",
    "OFFLINE",
    "OTHER",
]);
exports.leadAttributionSourceStatusSchema = zod_1.z.enum(["ACTIVE", "ARCHIVED"]);
exports.leadAttributionSourceSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    key: exports.leadAttributionSourceKeySchema,
    name: zod_1.z.string().trim().min(1).max(120),
    description: zod_1.z.string().trim().max(300).nullable(),
    kind: exports.leadAttributionSourceKindSchema,
    category: exports.leadAttributionSourceCategorySchema,
    status: exports.leadAttributionSourceStatusSchema,
    createdAt: zod_1.z.string().datetime({ offset: true }),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
    archivedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
});
exports.leadAttributionSourceListQuerySchema = zod_1.z.object({
    status: exports.leadAttributionSourceStatusSchema.optional(),
    search: zod_1.z.string().trim().max(120).optional(),
});
exports.leadAttributionSourceListResponseSchema = zod_1.z.object({
    sources: zod_1.z.array(exports.leadAttributionSourceSchema),
});
exports.createLeadAttributionSourceRequestSchema = zod_1.z.object({
    key: exports.leadAttributionSourceKeySchema,
    name: zod_1.z.string().trim().min(1).max(120),
    description: zod_1.z.string().trim().max(300).nullable().default(null),
    category: exports.leadAttributionSourceCategorySchema,
});
exports.updateLeadAttributionSourceRequestSchema = zod_1.z
    .object({
    name: zod_1.z.string().trim().min(1).max(120).optional(),
    description: zod_1.z.string().trim().max(300).nullable().optional(),
    category: exports.leadAttributionSourceCategorySchema.optional(),
})
    .refine((value) => Object.keys(value).length > 0, {
    message: "At least one field must be provided.",
});
/** Immutable copy stored when a lead/customer/job/estimate is created. */
exports.leadAttributionSnapshotSchema = zod_1.z.object({
    sourceId: zod_1.z.string().uuid(),
    sourceKey: exports.leadAttributionSourceKeySchema,
    sourceName: zod_1.z.string().trim().min(1).max(120),
    category: exports.leadAttributionSourceCategorySchema,
    channelKey: lead_channel_1.leadChannelKeySchema.nullable(),
    capturedAt: zod_1.z.string().datetime({ offset: true }),
});
//# sourceMappingURL=lead-attribution.js.map